import React, { useState, useEffect } from 'react';
import './MissionDetail.css';
import apiService from '../services/apiService';

const TYPE_MISSIONS = [
  { value: 'inspection_electrique', label: 'Électricité' },
  { value: 'vgp', label: 'Levage / VGP' },
  { value: 'thermographie', label: 'Thermographie' },
  { value: 'incendie', label: 'Incendie' },
];

function NouveauRapport({ onSuccess, onBack }) {
  const [clients, setClients] = useState([]);
  const [etablissements, setEtablissements] = useState([]);
  const [clientId, setClientId] = useState('');
  const [etablissementId, setEtablissementId] = useState('');
  const [datePrevue, setDatePrevue] = useState(() => {
    const d = new Date();
    return d.toISOString().slice(0, 10);
  });
  const [typeMission, setTypeMission] = useState('inspection_electrique');
  const [loading, setLoading] = useState(true);
  const [loadingEtablissements, setLoadingEtablissements] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await apiService.getClientsForFrais();
      if (!cancelled && res?.success && Array.isArray(res.clients)) {
        setClients(res.clients);
      }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!clientId) {
      setEtablissements([]);
      setEtablissementId('');
      return;
    }
    let cancelled = false;
    setLoadingEtablissements(true);
    setEtablissementId('');
    (async () => {
      const res = await apiService.getClientEtablissements(clientId);
      if (!cancelled && res?.success && Array.isArray(res.etablissements)) {
        setEtablissements(res.etablissements);
      }
      if (!cancelled) setLoadingEtablissements(false);
    })();
    return () => { cancelled = true; };
  }, [clientId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!etablissementId || !datePrevue || !typeMission) {
      setError('Veuillez sélectionner un établissement, une date et un type.');
      return;
    }
    setError(null);
    setSubmitting(true);
    try {
      const result = await apiService.createMission({
        etablissement_id: etablissementId,
        type_mission: typeMission,
        date_prevue: new Date(datePrevue).toISOString(),
      });
      if (result.success && result.data) {
        onSuccess(result.data);
      } else {
        setError(result.error || 'Erreur lors de la création');
      }
    } catch (err) {
      setError(err.message || 'Erreur réseau');
    } finally {
      setSubmitting(false);
    }
  };

  const clientLabel = (c) =>
    c.raisonSociale || c.entreprise || `${c.nom || ''} ${c.prenom || ''}`.trim() || c.id;

  return (
    <div className="mission-detail-container">
      <div className="mission-detail-header">
        <button type="button" className="back-button" onClick={onBack}>
          ← Retour
        </button>
        <h1>Nouveau rapport</h1>
        <span />
      </div>
      <div className="mission-detail-content">
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="detail-section">
            <div className="section-content">
              <label className="section-label" htmlFor="client">Client</label>
              <select
                id="client"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)}
                disabled={loading}
                style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e5e7eb' }}
              >
                <option value="">— Choisir un client —</option>
                {clients.map((c) => (
                  <option key={c.id} value={c.id}>{clientLabel(c)}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="detail-section">
            <div className="section-content">
              <label className="section-label" htmlFor="etablissement">Établissement</label>
              <select
                id="etablissement"
                value={etablissementId}
                onChange={(e) => setEtablissementId(e.target.value)}
                disabled={!clientId || loadingEtablissements}
                style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e5e7eb' }}
              >
                <option value="">— Choisir un établissement —</option>
                {etablissements.map((e) => (
                  <option key={e.id} value={e.id}>{e.nom || e.adresse || e.id}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="detail-section">
            <div className="section-content">
              <label className="section-label" htmlFor="date">Date prévue</label>
              <input
                id="date"
                type="date"
                value={datePrevue}
                onChange={(e) => setDatePrevue(e.target.value)}
                style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e5e7eb' }}
              />
            </div>
          </div>

          <div className="detail-section">
            <div className="section-content">
              <label className="section-label" htmlFor="type">Type de mission</label>
              <select
                id="type"
                value={typeMission}
                onChange={(e) => setTypeMission(e.target.value)}
                style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e5e7eb' }}
              >
                {TYPE_MISSIONS.map((t) => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>
          </div>

          {error && (
            <div style={{ color: '#dc2626', fontSize: 14 }}>{error}</div>
          )}

          <div className="mission-detail-actions">
            <button
              type="submit"
              className="action-button primary"
              disabled={submitting || !etablissementId}
            >
              {submitting ? 'Création…' : 'Créer la mission'}
            </button>
            <button type="button" className="action-button secondary" onClick={onBack}>
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NouveauRapport;
